import { Image, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { FetchFileFromS3 } from "Utility/Helpers/Storage";
import "../Pages/DigitalProfile/Styles/WidgetRender.css";

function CustomImage({
  S3Key,
  src = null,
  className,
  imagePreviewStyle,
  ...rest
}) {
  const [imageURL, setImageURL] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (S3Key) {
        await fetchURL(S3Key);
      }
    })();
  }, [S3Key]);

  const fetchURL = async (key) => {
    setIsLoading(true);
    try {
      const url = await FetchFileFromS3(key);
      if (url) {
        setImageURL(url);
      } else {
        setImageURL(null); // Handle undefined url
      }
    } catch (error) {
      console.error("Failed to fetch image from S3:", error);
      setImageURL(null); // Optional: Display a placeholder or error image
    } finally {
      setIsLoading(false);
    }
  };

  const getImagePath = () => (src ? src : imageURL ? imageURL : undefined);

  return (
    <div className={"flex justify-center items-center"}>
      {isLoading ? (
        <Skeleton.Image active size="default" className="skeleton-img" />
      ) : (
        <Image
          {...rest}
          preview={false}
          src={getImagePath()}
          className={`${imagePreviewStyle} ${className}`}
        />
      )}
    </div>
  );
}

export default CustomImage;
